import React from 'react'
import { connect } from 'react-redux'
import PlaylistDisplay from '../../playlist/PlaylistDisplay'
import { setDisplayedPlaylist } from '../../../redux/actions/playlists'
import { getDisplayedPlaylist } from '../../../redux/selectors/playlists'
import PropTypes from 'prop-types'
class ShowPageContent extends React.Component {
  componentDidMount () {
    this.props.setDisplayedPlaylist()
  }

  render () {
    return (
      <React.Fragment>
        {this.props.displayedPlaylist ? (
          <PlaylistDisplay
            playlist={this.props.displayedPlaylist}
            signedIn={this.props.signedIn}
            userIsAdmin={this.props.userIsAdmin}
            userIsAuthor={this.props.userIsAuthor}
            onDeleted={() => {
              window.location.href = `${window.location.origin}/my/playlists`
            }}
            onDuplicated={() => {
              window.location.href = `${window.location.origin}/my/playlists`
            }}
            includePlaylistAddedDates
          />
        ) : null}
      </React.Fragment>
    )
  }
}

ShowPageContent.propTypes = {
  displayedPlaylist: PropTypes.object,
  setDisplayedPlaylist: PropTypes.func,
  signedIn: PropTypes.bool,
  userIsAdmin: PropTypes.bool,
  userIsAuthor: PropTypes.bool
}

const mapStateToProps = state => {
  return {
    displayedPlaylist: getDisplayedPlaylist(state)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setDisplayedPlaylist: () => {
      dispatch(setDisplayedPlaylist(ownProps.playlist))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShowPageContent)
